import { render, staticRenderFns } from "./VuePagination.vue?vue&type=template&id=94911fd8&scoped=true&"
import script from "./VuePagination.vue?vue&type=script&lang=js&"
export * from "./VuePagination.vue?vue&type=script&lang=js&"
import style0 from "./VuePagination.vue?vue&type=style&index=0&id=94911fd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94911fd8",
  null
  
)

export default component.exports